<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">입장내역</span>
            <span class="txt">회원의 입장내역을 확인할 수 있습니다.</span>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                </div>
                <select-form
                    :select-data="['선택', ...periodTypeList]"
                    :select-value="['', ...periodTypeValueList]"
                    :selected-value="searchPeriod"
                    @update:set="(val) => (searchPeriod = val)"
                ></select-form>
                <div class="com-search-input">
                    <input v-model="searchStr" placeholder="회원명 입력" type="text" v-on:keyup.enter="onEventSearch" />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div>
            </div>
            <div class="line">
                <select-form
                    :select-data="['강사명', ...teacherList]"
                    :select-value="['', ...teacherValueList]"
                    :selected-value="teacherStaff"
                    @update:set="(val) => (teacherStaff = val)"
                ></select-form>
                <!-- <select-form :select-data='["출결상태", "출석미승인", "출석승인","입장","결석","대기"]' :select-value="['', '-','O', 'I','X', 'W']" @update:set="val => status = val" :selected-value="status"></select-form> -->
                <!-- <select-form :select-data='["디바이스","관리자웹","관리자앱","회원앱","터치모니터"]' :select-value="['', 'AW', 'AA', 'CA', 'TU']" @update:set="val => device = val" :selected-value="device"></select-form> -->
                <button class="com-search-reset" @click="resetSearchContent"></button>
            </div>
        </div>

        <div class="com-table-content">
            <table class="com-table">
                <colgroup>
                    <col style="width: 200px" />
                    <col style="width: 90px" />
                    <col style="width: 100px" />
                    <col style="width: 490px" />
                    <col style="width: 240px" />
                    <col style="width: 100px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button>시간</button>
                        </th>
                        <th>회원명</th>
                        <th>출석번호</th>
                        <th>
                            <button>이용권명</button>
                        </th>
                        <th>
                            <button>수업일자</button>
                        </th>
                        <th>
                            <button>강사명</button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(e, index) in entranceList" :key="index">
                        <td>{{ convertTime2(e.cth_entr_dt) }}</td>
                        <td>
                            <router-link
                                :to="{
                                    path: `/madmin/member/payment/${e.ccp_center_id}`,
                                    query: { customerId: e.ccp_center_cust_id },
                                }"
                                class="link"
                            >
                                {{ e.cust_namee }}
                            </router-link>
                        </td>
                        <td>{{ e.cust_atnd_no }}</td>
                        <td class="left">
                            <span v-if="e.cp_ticket_type_cd == 'P'" class="ico type-1">[개인]</span>
                            <span v-if="e.cp_ticket_type_cd == 'G'" class="ico type-2">[그룹]</span>
                            <span v-if="e.cp_ticket_type_cd == 'C'" class="ico type-3">[쿠폰]</span>
                            <span v-if="e.cp_ticket_type_cd == 'T'" class="ico type-4">[회원권]</span>
                            <span v-if="e.cp_ticket_type_cd == 'D'" class="ico type-5">[듀엣]</span>
                            <span v-if="e.cp_ticket_type_cd == 'O'" class="ico type-6">[OT]</span>
                            <span v-if="e.cp_ticket_type_cd == 'S'" class="ico type-8">[운동복]</span>
                            <router-link
                                :to="{
                                    path: `/madmin/member/account/${e.cp_center_id}`,
                                    query: { customerId: e.ccp_center_cust_id, contractId: e.ccp_center_contract_id },
                                }"
                                class="link"
                            >
                                {{ e.cp_namee }}
                            </router-link>
                        </td>
                        <td>{{ convertTime(e.cth_less_dt) }}</td>
                        <td>{{ e.cs_namee }}</td>
                    </tr>
                    <tr v-if="entranceList.length == 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
            <b-pagination
                v-model="pagingInfo.page"
                :per-page="pagingInfo.limit"
                :total-rows="pagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            ></b-pagination>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import EventBus from '@/assets/js/eventBus';
import { pagingInfo } from '@/assets/js/common';
import {mapGetters} from 'vuex';

export default {
    name: 'MypageList',
    props: {},
    computed: {
        ...mapGetters({
            centerId: 'auth/cId',
        }),
    },
    watch: {
        searchPeriod(newValue) {
            // 검색 기간 설정 변수
            this.searchPeriod = newValue;

            if (newValue === 'today') {
                // 오늘
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                // 어제
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'thisMonth') {
                // 이번 달
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                // 지난 달
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === '3M') {
                // 3개월
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '6M') {
                // 6개월
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '12M') {
                // 12개월
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '') {
                this.initStartDate();
                this.initEndDate();
            }
            this.onEntranceList();
        },
        startDate(newValue) {
            // 검색 시작일
            this.startDate = newValue;
        },
        endDate(newValue) {
            // 검색 종료일
            this.endDate = newValue;
        },
        teacherStaff(newValue) {
            this.teacherStaff = newValue;
            this.onEntranceList();
        },
        status(newValue) {
            this.status = newValue;
            this.onEntranceList();
        },
        device(newValue) {
            this.device = newValue;
            this.onEntranceList();
        },
    },
    data() {
        return {
            entranceList: [], // 리스트 관련

            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],
            pagingInfo: { ...pagingInfo },
            periodTypeList: [...this.$periodTypeList],
            periodTypeValueList: [...this.$periodTypeValueList],
            searchStr: '', // 이름
            searchPeriod: '', // 검색 기간 설정

            startDate: moment().format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
            teacherList: [], // 강사 직원
            teacherValueList: [],
            teacherStaff: '',
            status: '',
            device: '',
        };
    },
    mounted() {
        this.centerId = this.cId; // 센터id
        this.init();
    },
    methods: {
        // 초기화
        async init() {
            try {
                await this.onEntranceList(); // 예약 리스트 확인
                await this.onFetchTeachers(); // 강사명 조회 값 넣기.
            } catch (error) {
                console.log(error);
                console.log('초기화 에러입니다.');
            }
        },
        async onEntranceList() {
            try {
                const { data } = await this.getEntranceList();
                this.entranceList = data.items;
                this.setPageParams(data);
                console.log('입장출결 리스트', data);
            } catch (error) {
                console.log(error);
                console.log('예약리스트가 없습니다.');
            }
        },
        getEntranceList() {
            // 스웨거 검색: 회원별 센터강의 입장/출결 목록조회(페이징)
            return api.get(`/admin/api/center/${this.centerId}/lesson/schedule/customer/attendance/all`, {
                params: {
                    startDate: moment(this.startDate).format('YYYYMMDD'),
                    endDate: moment(this.endDate).format('YYYYMMDD'),
                    centerStaffId: this.teacherStaff,
                    centerCustomerName: this.searchStr,
                    attendanceStatus: this.status,
                    attendanceDevice: this.device,
                    justAttendData: true,
                    ...this.pagingInfo,
                },
            });
        },
        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onEntranceList();
        },

        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onEntranceList();
        },
        // 검색 조건 초기화
        resetSearchContent() {
            this.searchType = '';
            this.teacherStaff = '';
            this.status = '';
            this.device = '';
            this.onEntranceList();
            EventBus.$emit('event:initList', 'init');
        },
        // 페이징 기본값
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 검색 시작일 초기화
        initStartDate() {
            const startDate = moment().subtract(1, 'years').format('YYYY-MM-DD');
            this.startDate = startDate;
        },

        // 검색 종료일 초기화
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            this.endDate = endDate;
        },
        // 회원 목록 키워드 검색 이벤트
        onEventSearch(e) {
            // if (this.searchStr.length > 0 && this.searchStr.length < 2) {
            //     return;
            // }
            this.onEntranceList();
        },
        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.onEntranceList();
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            this.onEntranceList();
        },
        // 강사 리스트 조회
        async onFetchTeachers() {
            try {
                const { data } = await this.getFetchTeachers();
                data.sort(
                    (
                        a,
                        b // order by 정렬
                    ) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
                );
                console.log('강사 리스트', data);
                data.forEach((g) => {
                    this.teacherList.push(g.name);
                    this.teacherValueList.push(g.centerStaffId);
                });
            } catch (error) {
                console.log(error);
                console.log('에러입니다.');
            }
        },
        // 강사 리스트 조회 api
        getFetchTeachers() {
            return api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
        },
        // 상태변환
        convertStatus(type) {
            if (type === '-') {
                return '출석미승인';
            } else if (type === 'O') {
                return '출석승인';
            } else if (type === 'I') {
                return '입장';
            } else if (type === 'X') {
                return '결석';
            } else if (type === 'W') {
                return '대기';
            }
            return '';
        },
        // 장비변환
        convertDevice(type) {
            if (type === 'AW') {
                return '관리자WEB';
            } else if (type === 'AA') {
                return '관리자APP';
            } else if (type === 'CA') {
                return '회원APP';
            } else if (type === 'TU') {
                return '터치모니터';
            }
            return '';
        },
        convertTime(time) {
            return time ? moment(time).subtract('hours', 9).locale('ko').format('YYYY.MM.DD (ddd) HH:mm:SS') : '-';
        },
        convertTime2(time) {
            return time ? moment(time).locale('ko').format('YYYY.MM.DD HH:mm:SS') : '-';
        },
    },
};
</script>
<style lang="scss"></style>
